export const RESET = 'EXCMDEVICEPERIPHERALDEVICE_UPDATE_RESET'
export const SET_ERROR = 'EXCMDEVICEPERIPHERALDEVICE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMDEVICEPERIPHERALDEVICE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMDEVICEPERIPHERALDEVICE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMDEVICEPERIPHERALDEVICE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMDEVICEPERIPHERALDEVICE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMDEVICEPERIPHERALDEVICE_UPDATE_UPDATE_RETRIEVED'
